import styled from 'styled-components';

export const Container = styled.div`
  border-radius: var(--border-radius8);
  background: #f5f5f5;
  display: flex;
  margin-top: 15px;
`;
